if (!customElements.get('range-selector')) {
  class RangeSelector extends HTMLElement {
    constructor() {
      super();
      this.id = this.dataset.id;
    }
    
    connectedCallback() {
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.init();
              this.observer.unobserve(this);
            }
          })
        },
        { rootMargin: '0px', threshold: 0.1 }
      );
      this.observer.observe(this);
      
      this.insertAdjacentHTML("beforeend", `
        <style>
          [data-id="${this.id}"] [data-highlight] {
            width: calc((var(--x-2) - var(--x-1)));
            left: calc(var(--x-1));
          }
          
          [data-id="${this.id}"] [data-handle="left"]  {
            left: calc(var(--x-1));
          }
          
          [data-id="${this.id}"] [data-handle="right"]  {
            left: calc(var(--x-2));
          }
        </style>
      `);
    }
    
    init() {
      this.range = this.querySelector('[data-track]');
      this.min = Number(this.range.dataset.min);
      this.max = Number(this.range.dataset.max)
      this.handles = [...this.range.querySelectorAll("[data-handle]")];
      this.startPos = 100;
      this.activeHandle;
      this.displayMin = this.querySelector('[data-display-min]');
      this.displayMax = this.querySelector('[data-display-max]');
      
      this.handles.forEach(handle => {
        handle.addEventListener("mousedown", this.startMove.bind(this))
        handle.addEventListener("touchstart", this.startMoveTouch.bind(this))
      })
      
      window.addEventListener("mouseup", this.stopMove.bind(this))
      window.addEventListener("touchend", this.stopMove.bind(this))
      window.addEventListener("touchcancel", this.stopMove.bind(this))
      window.addEventListener("touchleave", this.stopMove.bind(this))
      
      const rangeRect = this.range.getBoundingClientRect();
      const handleRect = this.handles[0].getBoundingClientRect();
      
      this.range.style.setProperty("--x-1", `${0 - (handleRect.width / 2)}px`);
      this.range.style.setProperty("--x-2", rangeRect.width - handleRect.width / 2 + "px");
      this.handles[0].dataset.value = this.range.dataset.min;
      this.handles[1].dataset.value = this.range.dataset.max;
      this.querySelector('[data-display-min]').value = this.handles[0].dataset.value;
      this.querySelector('[data-display-max]').value = this.handles[1].dataset.value;
    }
    
    startMoveTouch(e) {
      const handleRect = e.target.getBoundingClientRect()
      
      this.startPos = e.touches[0].clientX - handleRect.x;
      this.activeHandle = e.target.closest('[data-handle]');
      this.moveTouchListener = this.moveTouch.bind(this);      
      window.addEventListener("touchmove", this.moveTouchListener);
    }
    
    startMove(e) {
      this.startPos = e.offsetX;
      this.activeHandle = e.target.closest('[data-handle]');
      this.moveListener = this.move.bind(this);

      window.addEventListener("mousemove", this.moveListener);
    }
    
    moveTouch(e) {
      this.move({ clientX: e.touches[0].clientX })
    }
    
    move(e) {
      const isLeft = this.activeHandle.dataset.handle === "left";
      const property = isLeft ? "--x-1" : "--x-2";
      const parentRect = this.range.getBoundingClientRect();
      const handleRect = this.activeHandle.getBoundingClientRect();
      let newX = e.clientX - parentRect.x - this.startPos;
      if ( isLeft) {
        const otherX = parseInt(this.range.style.getPropertyValue("--x-2"));
        
        newX = Math.min(newX, otherX - handleRect.width);
        newX = Math.max(newX, 0 - handleRect.width / 2);
        this.displayMin.dispatchEvent(new Event('change', { 'bubbles': true }));
      } else {
        const otherX = parseInt(this.range.style.getPropertyValue("--x-1"));
        
        newX = Math.max(newX, otherX + handleRect.width)
        newX = Math.min(newX, parentRect.width - handleRect.width / 2);
        this.displayMax.dispatchEvent(new Event('change', { 'bubbles': true }));
      }
      
      this.activeHandle.dataset.value = this.calcHandleValue((newX + handleRect.width/2) / parentRect.width);
      
      this.range.style.setProperty(property, newX + "px");
      this.displayMin.value = this.handles[0].dataset.value;
      this.displayMax.value = this.handles[1].dataset.value;
    }
    
    calcHandleValue(percentage) {
      return Math.round(percentage * (this.max - this.min) + this.min);
    }
    
    stopMove() {
      window.removeEventListener("mousemove", this.moveListener);
      window.removeEventListener("touchmove", this.moveTouchListener);
    }
  }
  
  customElements.define('range-selector', RangeSelector);
}